import * as React from 'react';
import {
	BooleanInput,
	Edit,
	EditProps,
	NumberInput,
	SelectArrayInput,
	SelectInput,
	SimpleForm,
	TextInput,
	useNotify,
	useTranslate
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import './OrganizationEdit.scss';
import { ELanguage } from '../enums';

export const OrganizationEdit = (props: EditProps): React.ReactElement => {
	const notify = useNotify();
	const translator = useTranslate();

	return (
		<Edit {...props} undoable={false} onSuccess={() => notify(translator('SAVED_SUCCESSFULLY'))}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} multiline={true} minRows={4} source="description" label="ABOUT_ORGANIZATION"/>
				<TextInput step={1} source="name" label="NAME"/>
				<UploadImage step={1} source="logoImageUrl" label="LOGO_IMAGE"/>
				<UploadImage step={1} source="dynamicCategoryDefaultImage" label="DYNAMIC_CATEGORY_DEFAULT_IMAGE"/>
				<TextInput step={1} source="address.addressStr" label="ADDRESS"/>
				<SelectArrayInput step={1} source="supportedLanguages" label="SUPPORTED_LANGUAGES" emptyText=""
				                  choices={Object.keys(ELanguage).map(key => ({
					                  id: ELanguage[key],
					                  name: ELanguage[key]
				                  }))}/>
				<SelectInput step={1} source="defaultLanguage" label="DEFAULT_LANGUAGE" emptyText=""
				             choices={Object.keys(ELanguage).map(key => ({
					             id: ELanguage[key],
					             name: ELanguage[key]
				             }))}/>
				<BooleanInput step={1} source="marathonsFlag" label="MARATHONS_FLAG"/>
				<BooleanInput step={1} source="successStoryFlag" label="SUCCESS_STORY_FLAG"/>
				<BooleanInput step={1} source="isCoachFolderPublic" label="COACH_FOLDER_FLAG"/>
				<TextInput className="message-edit" step={1} source="coachFolderName"
				           label="COACH_FOLDER_NAME"/>
			</SimpleForm>
		</Edit>
	);
};
